export const info = {
    "name": "Mary Faynik",

    "links": {
        "github": "https://github.com/maryfaynik",
        "linkedin": "https://www.linkedin.com/in/mary-faynik/",
    }
}
    
